import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonial from './components/Testimonial';
import Properties from './components/Properties';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Features />
      <Testimonial />
      <Properties />
      <CTA />
      <Footer />
    </div>
  );
}
